module.exports = "/images/blister-9.png";